$(function(){
//mini header
	var $header = $('.js-header');
	function fixedHeader(){
		if($(window).scrollTop() > 100 ){
			$header.addClass("is-fixed");
		}
		else {
			$header.removeClass("is-fixed");
		}
	}
	fixedHeader();
	$(window).scroll(function() {
		fixedHeader();
	});
});

